export const SECONDS_IN_MILLISECONDS = 1000;
export const POLLING_TIMEOUT_IN_SECONDS = 300;
